import { render, staticRenderFns } from "./OrgDetail.vue?vue&type=template&id=acaace16&scoped=true"
import script from "./OrgDetail.vue?vue&type=script&lang=js"
export * from "./OrgDetail.vue?vue&type=script&lang=js"
import style0 from "./OrgDetail.vue?vue&type=style&index=0&id=acaace16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaace16",
  null
  
)

export default component.exports